import { apiSlice } from './apiSlice';
import { SALES_URL } from '../constants';

export const salesApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Create a new sale
    createSale: builder.mutation({
      query: (sale) => ({
        url: SALES_URL,
        method: 'POST',
        body: sale,
      }),
    }),

    // Get sale details by ID
    getSaleDetails: builder.query({
      query: (id) => ({
        url: `${SALES_URL}/${id}`,
      }),
      keepUnusedDataFor: 5,
    }),

    // Get logged-in user's sales
    getMySales: builder.query({
      query: () => ({
        url: `${SALES_URL}/mine`,
      }),
      keepUnusedDataFor: 5,
    }),

    // Get all sales (Admin)
    getSales: builder.query({
      query: () => ({
        url: SALES_URL,
      }),
      keepUnusedDataFor: 5,
    }),

    // Mark sale as delivered
    deliverSale: builder.mutation({
      query: (saleId) => ({
        url: `${SALES_URL}/${saleId}/deliver`,
        method: 'PUT',
      }),
    }),

    // Delete sale
    deleteSale: builder.mutation({
      query: (saleId) => ({
        url: `${SALES_URL}/${saleId}`,
        method: 'DELETE',
      }),
    }),

    // Delete specific sale items
    deleteSaleItems: builder.mutation({
      query: ({ saleId, saleItemsIndexes }) => ({
        url: `${SALES_URL}/${saleId}/delete-items`,
        method: 'PUT',
        body: { saleItemsIndexes },
      }),
    }),

    // Update sale
    updateSale: builder.mutation({
      query: ({ saleId, ...body }) => ({
        url: `${SALES_URL}/${saleId}`,
        method: 'PUT',
        body,
      }),
    }),

    // ⭐ NEW: Fix missing product IDs (admin)
    fixMissingProductIds: builder.mutation({
      query: () => ({
        url: `${SALES_URL}/fix-missing-ids`,
        method: 'PUT',
      }),
    }),

    // ⭐ NEW: Repair ALL sales (admin)
    repairAllSales: builder.mutation({
      query: () => ({
        url: `${SALES_URL}/repair-all`,
        method: 'PUT',
      }),
    }),
  }),
});

export const {
  useCreateSaleMutation,
  useGetSaleDetailsQuery,
  useGetMySalesQuery,
  useGetSalesQuery,
  useDeliverSaleMutation,
  useDeleteSaleMutation,
  useDeleteSaleItemsMutation,
  useUpdateSaleMutation,
  useFixMissingProductIdsMutation,   // ⭐ NEW
  useRepairAllSalesMutation,         // ⭐ NEW
} = salesApiSlice;
